// extracted by mini-css-extract-plugin
module.exports = {"geshuiText":"geshuiText___10T7l"};